// extracted by mini-css-extract-plugin
export default {"studentsCount":"CourseItem_studentsCount__-5rqp","mainPrice":"CourseItem_mainPrice__QIMKP"};